export const updateTooltipPosition = (
  labelHeight: number,
  point: Highcharts.TooltipPositionerPointObject,
  chart: Highcharts.Chart,
  isXS: boolean,
  selectorId: string,
  // Beside the point at its height, kept inside the plot, instead of above it.
  alignToPoint = false
) => {
  const { chartWidth, plotLeft, plotTop, plotHeight } = chart;
  const containerPadding = 16;
  const tooltipElement = document.querySelector(selectorId);
  const tooltipWidth =
    tooltipElement?.getBoundingClientRect().width || (alignToPoint ? 160 : 310);

  let x = isXS ? (chartWidth - tooltipWidth) / 2 : point.plotX + plotLeft + 10;
  // Highcharts reports next to no height for this HTML tooltip, so a tooltip
  // kept inside the plot measures itself.
  const tooltipHeight =
    (alignToPoint && tooltipElement?.getBoundingClientRect().height) ||
    labelHeight;
  const y = alignToPoint
    ? Math.min(
        Math.max(plotTop + point.plotY - tooltipHeight / 2, plotTop),
        plotTop + plotHeight - tooltipHeight
      )
    : plotTop - labelHeight / 2;

  if (!isXS && x + tooltipWidth + containerPadding > chartWidth) {
    x = point.plotX + plotLeft - tooltipWidth - 10;
  }

  // Never past the right edge either: a wide tooltip next to a point near the
  // middle fits neither side and would otherwise run off the chart.
  if (alignToPoint) {
    x = Math.min(x, chartWidth - tooltipWidth - containerPadding);
  }
  x = Math.max(plotLeft + containerPadding, x);

  return { x, y };
};
